import Vue from 'vue'
import Vuex from 'vuex'
import login from './login/index'
import transactions from './transactions/index'
import request from './request/index'
Vue.use(Vuex)

const Store = new Vuex.Store({
  modules: {
    login,
    transactions,
    request
  }
})

export default Store



// WEBPACK FOOTER //
// ./src/store/store.js